module.exports = __webpack_public_path__ + "img/8.ade17bfa.png";